import type { StylableProps } from "@mdotm/shadcn/legacy/components";
import { toClassName } from "@mdotm/shadcn/legacy/react-extensions";

/** An empty dustpan "clear" glyph. Inherits text color via `currentColor`. */
export function EmptyIcon({
	size = 24,
	color = "currentColor",
	style,
	className,
}: { size?: number; color?: string } & StylableProps): React.JSX.Element {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			style={style}
			className={toClassName(className)}
			aria-hidden="true"
		>
			<path
				d="M20.25 14.75H16.6182C16.5236 14.75 16.4367 14.8037 16.3936 14.8896L16.3926 14.8887L15.9463 15.7803L15.9473 15.7812C15.6513 16.375 15.045 16.75 14.3818 16.75H9.61816C8.95473 16.75 8.34963 16.3752 8.05273 15.7832L8.05176 15.7822L7.60547 14.8887L7.60449 14.8877C7.56249 14.8035 7.47668 14.75 7.38184 14.75H3.75V18C3.75 18.6908 4.30921 19.25 5 19.25H19C19.6908 19.25 20.25 18.6908 20.25 18V14.75ZM21.75 18C21.75 19.5192 20.5192 20.75 19 20.75H5C3.48079 20.75 2.25 19.5192 2.25 18V14.3633C2.25 14.1929 2.26668 14.0232 2.29785 13.8564C2.29894 13.8509 2.30055 13.8454 2.30176 13.8398C2.33078 13.6897 2.37109 13.5413 2.4248 13.3975C2.42737 13.3906 2.42985 13.3837 2.43262 13.377L4.41699 8.51465C4.82496 7.4523 5.84486 6.75 6.98438 6.75H8.59766C9.01187 6.75 9.34766 7.08579 9.34766 7.5C9.34766 7.91421 9.01187 8.25 8.59766 8.25H6.98438C6.46307 8.25 5.99671 8.57311 5.81348 9.06152C5.81101 9.06809 5.80831 9.07456 5.80566 9.08105L4.10449 13.25H7.38184C8.04467 13.25 8.65014 13.6245 8.94629 14.2178L9.39258 15.1104C9.43569 15.1963 9.52363 15.25 9.61816 15.25H14.3818C14.4767 15.25 14.5625 15.1965 14.6045 15.1123L14.6055 15.1113L15.0527 14.2168C15.3496 13.6248 15.9547 13.25 16.6182 13.25H19.7734L17.4346 9.1709C17.4145 9.13585 17.397 9.09935 17.3828 9.06152C17.1996 8.57311 16.7332 8.25 16.2119 8.25H14.5977C14.1836 8.24977 13.8477 7.91407 13.8477 7.5C13.8477 7.08593 14.1836 6.75023 14.5977 6.75H16.2119C17.3319 6.75 18.3344 7.4291 18.7559 8.46094L21.5234 13.2881L21.5752 13.3975C21.6291 13.5413 21.6692 13.6896 21.6982 13.8398C21.6994 13.8454 21.7011 13.8509 21.7021 13.8564C21.7334 14.0233 21.75 14.193 21.75 14.3633V18Z"
				fill={color}
			/>
			<path
				d="M6.21746 2.53189C6.50912 2.23778 6.98399 2.23579 7.27811 2.52745L8.47811 3.71746C8.77222 4.00912 8.77421 4.48399 8.48254 4.77811C8.19088 5.07222 7.71601 5.07421 7.42189 4.78255L6.22189 3.59254C5.92778 3.30088 5.92579 2.82601 6.21746 2.53189Z"
				fill={color}
			/>
			<path
				d="M17.7825 2.53189C17.4909 2.23778 17.016 2.23579 16.7219 2.52745L15.5219 3.71746C15.2278 4.00912 15.2258 4.48399 15.5175 4.77811C15.8091 5.07222 16.284 5.07421 16.5781 4.78255L17.7781 3.59254C18.0722 3.30088 18.0742 2.82601 17.7825 2.53189Z"
				fill={color}
			/>
			<path
				d="M11.75 4.19019C11.3358 4.19019 11 3.8544 11 3.44019V1.75019C11 1.33597 11.3358 1.00019 11.75 1.00019C12.1642 1.00019 12.5 1.33597 12.5 1.75019V3.44019C12.5 3.8544 12.1642 4.19019 11.75 4.19019Z"
				fill={color}
			/>
		</svg>
	);
}
